import { EscHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useDisableIntegration } from '@modules/integrationsV2/hooks';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { IntegrationChannelType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

interface DisableIntegrationConfirmationModalProps {
  channelType: IntegrationChannelType;
  integrationID: UUID;
}

export const DisableIntegrationConfirmationModal = ({
  integrationID,
  channelType,
}: DisableIntegrationConfirmationModalProps) => {
  const { closeModal } = useMuiModalContext();

  const { disableIntegration, isLoading } = useDisableIntegration({
    channelType,
    onCompleted: () => {
      closeModal();
    },
  });

  return (
    <>
      <ModalHeader
        title={`Disable ${channelType} Integration?`}
        showCloseButton={false}
      />
      <DialogContent dividers>
        <Typography variant="body2">
          Enterpret will stop ingesting data from this integration once
          disabled. Previously ingested data will continue to be available for
          analysis.
        </Typography>
        <Alert severity="warning" sx={{ mt: 4, borderRadius: 1 }}>
          Disabling this integration is irreversible. You can still create a new
          integration for the same source.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" m={2} spacing={2}>
          <Button
            variant="outlined"
            onClick={() => closeModal()}
            endIcon={<EscHotKeyIcon />}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            autoFocus
            onClick={() => disableIntegration(integrationID)}
            loading={isLoading}
            color="error"
          >
            Disable
          </LoadingButton>
        </Stack>
      </DialogActions>
    </>
  );
};
